export interface IGetCountryDto {
    isoNumericCode: string
    name: string
}

export default class Country {
    isoNumericCode: string
    name: string

    constructor(dto: IGetCountryDto) {
        this.isoNumericCode = dto.isoNumericCode
        this.name = dto.name
    }
}
